"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchRouteChangeEvent = dispatchRouteChangeEvent;
exports.dispatchRouteChangedEvent = dispatchRouteChangedEvent;
exports.dispatchAuthTransitionEvent = dispatchAuthTransitionEvent;
exports.dispatchUserUpdateEvent = dispatchUserUpdateEvent;
exports.dispatchMessageActionEvent = dispatchMessageActionEvent;
const enums_1 = require("../../types/enums");
const authTransitionTypeToEventType = {
    [enums_1.AuthTransitionType.LOGIN]: enums_1.EventName.AUTH_CHANGE,
    [enums_1.AuthTransitionType.LOGOUT]: enums_1.EventName.AUTH_CHANGE,
    [enums_1.AuthTransitionType.LOCK_OUT]: enums_1.EventName.AUTH_CHANGE,
    [enums_1.AuthTransitionType.FORGOT_PASSWORD]: enums_1.EventName.AUTH_CHANGE,
    [enums_1.AuthTransitionType.REGISTRATION]: enums_1.EventName.USER_REGISTERED,
    [enums_1.AuthTransitionType.CLOSE_ACCOUNT]: enums_1.EventName.CLOSE_ACCOUNT
};
const messageActionTypeToEventType = {
    [enums_1.MessageActionType.CREATE]: enums_1.EventName.MESSAGE_CREATED,
    [enums_1.MessageActionType.EDIT]: enums_1.EventName.MESSAGE_EDITED,
    [enums_1.MessageActionType.DELETE]: enums_1.EventName.MESSAGE_DELETED,
    [enums_1.MessageActionType.MOVE]: enums_1.EventName.MESSAGE_MOVED
};
function dispatchEvent(eventName, detail) {
    global.dispatchEvent(new CustomEvent(eventName, { detail }));
}
/**
 * Dispatches an event for a given Entity with the given parameters.
 * @param eventName the name of the event.
 * @param source the source entity of the event. Generally, this is the entity that was acted upon.
 * @param userEditor the id of the user who took the action which led to the event.
 * @param target optional target entity of the event.
 * If the event is related to a relationship between two entities, this is the other entity.
 * @param changeSet optional object containing the changes made to the source entity.
 */
function dispatchEntityEvent(eventName, source, userEditor, target, changeSet) {
    const detail = {
        eventName: eventName,
        source: source,
        target: null,
        userEditor: null,
        changeSet: null
    };
    if (target) {
        detail.target = target;
    }
    if (userEditor) {
        detail.userEditor = userEditor;
    }
    if (changeSet) {
        detail.changeSet = changeSet;
    }
    dispatchEvent(eventName, { detail });
}
/**
 * Dispatches an event for the start of a route change.
 * @param pathInfo the new route information.
 * @param previous the previous route information.
 */
function dispatchRouteChangeEvent(pathInfo, previous) {
    const detail = { incoming: pathInfo, previous };
    dispatchEvent(enums_1.EventName.ROUTE_CHANGE, {
        detail: detail
    });
}
/**
 * Dispatches an event for the completion of a route change.
 * This should only fire after the DOM has been updated for a given route change.
 * @param pathInfo the new route information.
 * @param previous the previous route information.
 */
function dispatchRouteChangedEvent(pathInfo, previous) {
    const detail = { actual: pathInfo, previous };
    dispatchEvent(enums_1.EventName.ROUTE_CHANGED, {
        detail: detail
    });
}
/**
 * Dispatches an event for an auth-related transition.
 * @param transitionType the type of transition that occurred.
 * @param authUser the user that initiated the transition.
 * @param changeSet related information about the transition.
 */
function dispatchAuthTransitionEvent(transitionType, authUser, changeSet) {
    dispatchEntityEvent(authTransitionTypeToEventType[transitionType], authUser, authUser === null || authUser === void 0 ? void 0 : authUser.id, undefined, Object.assign({ transitionType }, changeSet));
}
/**
 * Dispatches an event for a user update.
 * @param updateType the type of update that occurred.
 * @param updatedUser the user that was updated.
 * @param userEditor the user that performed the update. Will default to the updated user if not provided.
 * @param changeSet related information about the update.
 */
function dispatchUserUpdateEvent(updateType, updatedUser, userEditor, changeSet = {}) {
    dispatchEntityEvent(enums_1.EventName.USER_UPDATED, updatedUser, userEditor !== null && userEditor !== void 0 ? userEditor : updatedUser.id, undefined, Object.assign({ updateType }, changeSet));
}
/**
 * Dispatches an event for an action taken on a Message.
 * @param actionType the type of action that occurred.
 * @param message the Message that was acted upon.
 * @param messageActor the user that performed the action.
 * @param targetMessage optional target Message of the action.
 * @param changeSet related information about the action.
 */
function dispatchMessageActionEvent(actionType, message, messageActor, targetMessage, changeSet) {
    dispatchEntityEvent(messageActionTypeToEventType[actionType], message, messageActor, targetMessage, Object.assign({ actionType }, changeSet));
}
//# sourceMappingURL=EventHelper.js.map